module.exports = __webpack_public_path__ + "img/index-ydn.d3aa3634.png";